<template>
    <div id="app" class="avp-app container">
        <div class="avp-app-wrapper row">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 avp-app-content">
                <div class="card">
                    <div class="card-header avp-card-header">
                        <CardHeader/>
                    </div>
                    <div class="card-body">
                        <div class="card-body-content">
                            <div v-if="isLoading">
                                <div class="text-center">
                                    <SpinnerIcon class="icon spinner"/>
                                    <p>
                                        <template v-if="isManualCodeSelectionRequired && bookingNumber === ''">
                                            Laden der Produktinformationen - einen Augenblick bitte.
                                        </template>
                                        <template v-else>
                                            Wir überprüfen Ihre Partner-Gutscheinnummer - einen Moment bitte.
                                        </template>
                                    </p>
                                </div>
                            </div>
                            <div class="col-12" v-else-if="isJsmdCustomerServiceInfoVisible">
                                <section class="avp-card-section" style="margin-bottom: 40px;">
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <div v-if="errors && errors.length > 0">
                                                <ul class="list-group list-group-flush"
                                                    style="background-color: transparent !important; font-weight: bold; font-size: 1.2rem;"
                                                    v-for="error in errors" :key="error">
                                                    <li class="list-group-item text-danger text-center">{{ error }}</li>
                                                </ul>
                                            </div>
                                            <div
                                                style="border: 2px dashed red; padding-top: 20px;padding-right: 10px;padding-left: 10px;padding-bottom: 10px;font-size: 1rem;margin: 10px 0; ">
                                                <p class="text-center text-danger">
                                                    <b>Bitte beachten Sie, dass Sie Ihren Buchungscode immer zuerst<br/>bei
                                                        Jochen Schweizer bzw. MyDays einlösen müssen.</b>
                                                </p>
                                            </div>
                                            <p>
                                                Für weitere Fragen, kontaktieren Sie bitte ggf. den zuständigen
                                                Kundenservice:
                                            </p>
                                        </div>
                                        <div class="col-6 text-center customer-service-info">
                                            Jochen Schweizer Gutscheine<br/>
                                            <span><a
                                                href="https://jep.jochen-schweizer.de/l/de-de/portal/voucher/redemption"
                                                style="text-decoration: underline; color: #000; font-size:1rem;">Zur Einlöseseite</a></span><br/>
                                            <span>089 / 70 80 90 90</span>
                                        </div>
                                        <div class="col-6 text-center customer-service-info">
                                            Mydays Gutscheine<br/>
                                            <span><a href="https://jep.jsmd-group.com/l/de-de/mydays/voucher/redemption"
                                                     style="text-decoration: underline; color: #000; font-size:1rem;">Zur Einlöseseite</a></span><br/>
                                            <span>089 / 2112 999 33</span>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div v-else-if="isFormVisible">
                                <ErrorMessages :error-messages="errors"/>
                                <form class="form avp-form" role="form" autocomplete="off"
                                      v-on:submit.prevent="sendRequestData">
                                    <template v-if="isStep1Visible">
                                        <div v-if="isManualCodeSelectionRequired"
                                             style="border: 2px dashed red; padding: 20px 10px;font-size: 1.2rem;">
                                            <div class="row">
                                                <div class="col-12">
                                                    <p class="text-center text-danger">
                                                        <b>Bitte beachten Sie, dass Sie Ihren Buchungscode immer
                                                            zuerst<br/>bei Jochen Schweizer bzw. MyDays einlösen müssen.</b>
                                                    </p>
                                                </div>
                                                <div class="col-6 text-center customer-service-info">
                                                        <span><a
                                                            href="https://jep.jochen-schweizer.de/l/de-de/portal/voucher/redemption"
                                                            style="text-decoration: underline; color: #000; font-size:1rem;">Jochen Schweizer Einlöseseite</a></span><br/>
                                                </div>
                                                <div class="col-6 text-center customer-service-info">
                                                        <span><a
                                                            href="https://jep.jsmd-group.com/l/de-de/mydays/voucher/redemption"
                                                            style="text-decoration: underline; color: #000; font-size:1rem;">Mydays Einlöseseite</a></span><br/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12" v-if="isManualCodeSelectionRequired">
                                            <section class="avp-card-section">
                                                <h2 class="h4"><span>1</span>Anbieter wählen</h2>
                                                <div class="row">
                                                    <div class="col-2"></div>
                                                    <div class="col-4">
                                                        <input type="radio" id="mydays" value="MyDays" v-model="brand">&nbsp;<label
                                                        for="mydays">mydays</label>
                                                    </div>
                                                    <div class="col-6">
                                                        <input type="radio" id="jochenschweizer" value="JochenSchweizer"
                                                               v-model="brand">&nbsp;<label for="jochenschweizer">Jochen
                                                        Schweizer</label>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <section class="avp-card-section">
                                                    <template v-if="isManualCodeSelectionRequired">
                                                        <h2 class="h4"><span>2</span>Angaben zum Kauf</h2>
                                                        <div class="row">
                                                            <div class="col-12 col-md-6"><label for="avp-bookingNumber">Ihre
                                                                {{ currentBrand }}-Partnergutschein-Nummer*</label>
                                                            </div>
                                                            <div class="col-12 col-md-6 text-right text-sm-left"><a
                                                                href="#" v-if="currentBrand === 'mydays'"
                                                                @click="toggleInfoPanel">
                                                                <InfoIcon class="checkin-dates__info-icon"/>
                                                                Wo finde ich meine Partnergutschein-Nummer?</a></div>
                                                        </div>
                                                        <div class="row" v-if="infoPanelVisible">
                                                            <div class="col-12">
                                                                <img src="@/assets/mydays-ticket-lp.jpg" width="100%"
                                                                     class="mt-1 mb-3"/>
                                                            </div>
                                                        </div>
                                                        <div class="row" style="margin-bottom: 30px;">
                                                            <div class="col-9">
                                                                <input type="text" class="form-control"
                                                                       :placeholder=placeholderBookingNumber
                                                                       aria-describedby="gdpr-notice"
                                                                       v-model="bookingNumber"
                                                                       id="avp-bookingNumber"
                                                                       required>
                                                            </div>
                                                            <div class="col-3">
                                                                <button type="button" @click="checkCode"
                                                                        class="btn btn-primary">Prüfen
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <h2 class="h4"><span>1</span>Angaben zum Kauf</h2>
                                                        <div class="row">
                                                            <div class="col-12"><label for="avp-bookingNumber">Ihre
                                                                Buchungs- oder Gutscheinnummer</label></div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <input type="text" class="form-control disabled"
                                                                       v-model="bookingNumber"
                                                                       id="avp-bookingNumber"
                                                                       readonly disabled>
                                                            </div>
                                                        </div>
                                                    </template>

                                                    <template v-if="isProductPreselected">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <label for="avp-hotel">Hotel*</label>
                                                                <input type="text" class="form-control disabled"
                                                                       v-model="selectedHotel.text"
                                                                       id="avp-hotel"
                                                                       readonly disabled>
                                                            </div>
                                                        </div>
                                                        <div class="row" v-if="selectedHotel">
                                                            <div class="col-12">
                                                                <label for="avp-product">Gewähltes Produkt*</label>
                                                                <input type="text" class="form-control disabled"
                                                                       v-model="selectedProduct.text"
                                                                       id="avp-product"
                                                                       readonly disabled>
                                                            </div>
                                                        </div>
                                                        <div class="row" v-if="selectedProduct">
                                                            <div class="col-12">
                                                                <label for="avp-productVariantId">Gewähltes
                                                                    Arrangement*</label>
                                                                <input type="text" class="form-control disabled"
                                                                       v-model="selectedVariant.text"
                                                                       id="avp-productVariantId"
                                                                       readonly disabled>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </section>
                                            </div>
                                        </div>
                                        <div class="row mt-4" v-if="!isStep2Visible && selectedVariant != null">
                                            <div class="col-12 col-md-6 col-lg-6 mb-3 text-right">
                                                <div class="price-display">
                                                    <span class="label-finishorder">Gesamt</span>
                                                    <h2 class="text-right mb-0">0,00 €</h2>
                                                </div>
                                                <TickIcon class="icon-tick pr-1"/>
                                                Bereits bezahlt
                                            </div>
                                            <div
                                                class="col-12 col-md-6 col-lg-6 text-center text-md-right text-lg-right mt-4 mb-3">
                                                <button type="button" @click="showStep2" class="btn btn-primary">Zur
                                                    Reservierung
                                                </button>
                                            </div>
                                            <div class="col-12 mb-3">
                                                <h6 class="pt-2" style="border-top:1px dotted #999">Hiermit schließen
                                                    Sie Ihren Kaufprozess ab.</h6>
                                                <small>
                                                    Ich habe die <a href="https://www.animod.de/c/agb" target="_blank">AGB</a>
                                                    und die <a href="https://www.animod.de/c/datenschutz"
                                                               target="_blank">Datenschutzerklärung</a> von Animod
                                                    gelesen und akzeptiere diese. Zusätzlich wird
                                                    Ihre E-Mail-Adresse für unseren Newsletter verwendet, von dem Sie
                                                    sich selbstverständlich
                                                    jederzeit kostenfrei abmelden können.
                                                </small>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-if="isStep2Visible">
                                        <div class="row">
                                            <div class="col-12">
                                                <section
                                                    class="avp-date-selection avp-multi-date-selection checkin-dates">
                                                    <h2 class="h4 mt-3"><span v-if="isStep1Visible">3</span><span
                                                        v-else>1</span>Gewünschter Anreisetermin</h2>
                                                    <div class="row">
                                                        <div class="col-12" v-if="arrivalDatesComputed.length > 1">
                                                            <small class="text-secondary">Bitte geben Sie Ihren
                                                                gewünschten Anreisetermin sowie zwei Alternativtermine
                                                                an.</small>
                                                        </div>
                                                        <template v-for="(entry, index) in arrivalDatesComputed">

                                                            <datepicker
                                                                :value="entry"
                                                                :input-class="'col-12 dpi-' + index"
                                                                @selected="updateDate($event, index)"
                                                                placeholder="Termin wählen..."
                                                                :disabledDates="disabledDates"
                                                                :highlighted="highlightedDates"
                                                                :open-date="firstDate"
                                                                :bootstrap-styling="true"
                                                                :format="customFormatter"
                                                                :language="de"
                                                                :monday-first="true"
                                                                :name="'date_' + index"
                                                                :required="index === 0"
                                                                :typeable="false"
                                                                :class="datePickerClass"
                                                                :key="'datepicker' + index"
                                                                :ref="'datepicker' + index"
                                                            >
                                                                <template v-slot:afterDateInput>
                                                                    <span class="checkin-dates__suffix">{{
                                                                            appendDuration(index)
                                                                        }}</span>
                                                                    <ClearIcon v-if="entry"
                                                                               class="checkin-dates__icon checkin-dates__clear-icon"
                                                                               @click="clearDate(index)"/>
                                                                    <CalendarIcon
                                                                        class="checkin-dates__icon checkin-dates__calendar-icon"
                                                                        @click="openCalendar($event, index)"/>
                                                                </template>
                                                            </datepicker>
                                                            <div v-if="!singleDateSelection && !index"
                                                                 class="col-12 mb-2">
                                                                <small class="text-primary"
                                                                       v-if="arrivalDatesComputed.length > 1">
                                                                    WICHTIG: Bitte geben Sie mehr als einen Termin an.
                                                                    Je mehr Termine Sie angeben, desto wahrscheinlicher
                                                                    ist eine positive Rückmeldung des Hotels.
                                                                </small>
                                                            </div>
                                                            <div class="w-100"></div>
                                                        </template>

                                                    </div>

                                                </section>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <section class="avp-card-section">
                                                    <h2 class="h4 mt-3"><span v-if="isStep1Visible">4</span><span
                                                        v-else>2</span>Persönliche Daten</h2>
                                                    <div class="row">
                                                        <div class="col-12 col-sm-6">
                                                            <label for="avp-firstname">Vorname*</label>
                                                            <input type="text" name="firstname" id="avp-firstname"
                                                                   maxlength="80"
                                                                   v-model="firstname"
                                                                   class="form-control" required="required"
                                                                   placeholder="Max"/>
                                                        </div>
                                                        <div class="col-12 col-sm-6">
                                                            <label for="avp-lastname">Nachname*</label>
                                                            <input type="text" name="lastname" id="avp-lastname"
                                                                   maxlength="80"
                                                                   v-model="lastname"
                                                                   class="form-control" required="required"
                                                                   placeholder="Mustermann"/>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12 col-sm-6">
                                                            <label for="avp-email">E-Mail*</label>
                                                            <input type="email" name="emailAddress" id="avp-email"
                                                                   maxlength="200"
                                                                   v-model="email"
                                                                   class="form-control" required="required"
                                                                   placeholder="max.mustermann@example.org"/>
                                                        </div>
                                                        <div class="col-12 col-sm-6">
                                                            <label for="avp-phone">Telefon*</label>
                                                            <input type="phone" name="phone" id="avp-phone"
                                                                   maxlength="200"
                                                                   v-model="phone"
                                                                   class="form-control" required="required"
                                                                   placeholder=""/>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <label for="avp-email">Anmerkungen</label>
                                                            <b style="color:#e64706">
                                                                HINWEIS: Abweichende Terminwünsche in den Anmerkungen
                                                                können nicht berücksichtigt werden.
                                                                Bei Rückfragen zur Verfügbarkeit kontaktieren Sie bitte
                                                                den Animod-Kundenservice.
                                                            </b>
                                                            <textarea rows="4" name="comment" id="avp-comment"
                                                                      maxlength="2000"
                                                                      v-model="comment"
                                                                      class="form-control"
                                                                      placeholder="Anmerkungen für das Hotel betreffend der Buchung, bspw.
    - dass Sie ein Zustellbett benötigen
    - dass Sie ein barrierefreies Zimmer benötigen
    - dass Sie gerne einen Hund mitbringen möchten"></textarea>
                                                        </div>
                                                    </div>
                                                </section>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 text-center mt-4 mb-3">
                                                <button type="submit" class="btn btn-primary">Anfrage senden</button>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <p class="form-text text-muted small" id="gdpr-notice">
                                                    Durch Abschicken dieses Formulars stimmen Sie der Speicherung und
                                                    Verarbeitung
                                                    Ihrer Daten gemäß unserer <a
                                                    href="https://www.animod.de/c/datenschutz"
                                                    target="_blank">Datenschutzerklärung</a> zu.
                                                </p>
                                            </div>
                                        </div>
                                    </template>
                                </form>
                            </div>
                            <div v-else>
                                <p>
                                    Vielen Dank - Ihre Anfrage wird nun automatisch an das Hotel weitergeleitet. Das
                                    Hotel bearbeitet diese und sendet über unser System die Rückmeldung. Bitte beachten
                                    Sie, dass ausschließlich das Hotel eine Auskunft über Verfügbarkeiten und den
                                    Bearbeitungsstand geben kann.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer avp-card-footer">
                        <CardFooter/>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';

import CardHeader from './components/CardHeader';
import CardFooter from './components/CardFooter';
import ErrorMessages from "./components/ErrorMessages";
import Datepicker from 'vuejs-datepicker';
import {de, en} from 'vuejs-datepicker/dist/locale';
import CalendarIcon from './assets/calendar.svg';
import ClearIcon from './assets/close.svg';
import InfoIcon from './assets/info.svg';
import SpinnerIcon from './assets/spinner.svg';
import ApiClient from './ApiClient';
import Logger from './Logger';
import vSelect from 'vue-select'

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "vue-select/src/scss/vue-select.scss";

import TickIcon from "../../animod-shop-ssr/src/assets/icons/tick.svg";

Vue.use(BootstrapVue);
const ERR_NON_UNIQUE_DATES = "Bitte wählen Sie drei unterschiedliche Wunschtermine aus.";

export default {
    name: 'app',
    components: {
        TickIcon,
        ErrorMessages,
        CardHeader,
        CardFooter,
        Datepicker,
        vSelect,
        CalendarIcon,
        ClearIcon,
        InfoIcon,
        SpinnerIcon
    },
    data: function () {
        return {
            en: en,
            de: de,
            brand: "MyDays",
            bookingNumber: "",
            firstname: "",
            lastname: "",
            email: "",
            phone: "",
            comment: "",
            hotelSearch: "",
            selectedHotel: null,
            selectedProduct: null,
            selectedVariant: null,
            arrivalDates: [null, null, null],
            quantity: 1,
            errors: [],
            productData: [],
            isLoading: true,
            step: "show-form",
            infoPanelVisible: false,
            step1Finished: false,
            isProductPreselected: false,
            isCodeValidated: false,
            isJsmdCustomerServiceInfoVisible: false,
        };
    },
    computed: {
        arrivalDatesComputed: function () {
            let result = Array.from({
                    length: this.singleDateSelection ? 1 : 3
                },
                (item, index) => {
                    // console.log("this.arrivalDates[index]", this.singleDateSelection, index, this.arrivalDates[index]);
                    return ApiClient.methods.parseDate(this.arrivalDates[index]) || null;
                });
            // console.log("arrivalDatesComputed", result);
            return result;
        },
        datePickerClass: function () {
            return this.singleDateSelection ? 'col-12 col-md-8 col-xl-6 fullwidth-calendar' : 'col-12 col-md-6 ';
        },
        singleDateSelection: function () {
            if (this.selectedProduct) {
                return this.selectedProduct.backedByContingents;
            }
            return false;
        },
        availableDates: function () {
            if (this.selectedVariant && this.selectedVariant.backedByContingents) {
                return this.selectedVariant.vacancies;
            }
            if (this.selectedVariant && this.selectedVariant.vacancies) {
                return this.selectedVariant.vacancies;
            }
            return [];
        },
        highlightedDates() {
            return {
                dates: this.availableDates.map(dateString => ApiClient.methods.parseDate(dateString))
            };
        },
        disabledDates() {
            const datesCombined = new Set([
                ...(this.availableDates.length ? this.availableDates : []),
                ...this.arrivalDates.filter(date => !!date)
            ]);

            const lastDate = new Date();
            lastDate.setFullYear(lastDate.getFullYear() + 3);
            return {
                from: lastDate,
                to: new Date(),
                customPredictor: function (date) {
                    let predicate = datesCombined.size && !datesCombined.has(ApiClient.methods.formatDate(date));
                    //console.log(date, predicate);
                    return predicate;
                }.bind(this)
            };
        },
        firstDate() {
            return this.highlightedDates.dates ?
                [...this.highlightedDates.dates].sort((d1, d2) => {
                    if (d1 > d2) return 1;
                    else return -1;
                    //return d1 < d2
                })[0] : undefined;
        },

        codeFromUrl: function () {
            if (window.location.search && !this.isInternalMode) {
                const params = new URLSearchParams(window.location.search);
                let queryParams = {};

                for (const [key, value] of params.entries()) {
                    queryParams[key] = value;
                }
                let code = queryParams['code'];
                return code && code !== '' ? code : null;
            }
            return null;
        },

        isFormVisible: function () {
            return !this.loading && this.step === "show-form" && !this.isJsmdCustomerServiceInfoVisible;
        },
        productSelectionRequired: function () {
            return this.products && this.products.length && this.products.length > 1;
        },
        variantSelectionRequired: function () {
            return this.variants && this.variants.length && this.variants.length > 1;
        },
        selectedProductText: function () {
            return this.products && this.products.length === 1 ? this.products[0].text : "Bitte wählen Sie erst ein Hotel";
        },
        selectedVariantText: function () {
            return this.selectedVariant ? this.selectedVariant.text : "Bitte wählen Sie erst Hotel und Produkt";
        },
        placeholderBookingNumber: function () {
            return "Sie finden diese Nummer auf ihrem " + this.currentBrand + "-Ticket";
        },
        bookingNumberPattern: function () {
            return this.brand === 'MyDays' ? '[0-9]{7}' : '\S{16}';
        },
        currentBrand: function () {
            return (this.brand === 'MyDays' ? 'mydays' : this.brand);
        },
        hotels: function () {
            let hotelIds = new Set();
            let result = [];
            this.productData
                .map(function (value) {
                    return {
                        "id": value.hotelId,
                        "text": value.hotelName
                    };
                })
                .forEach(item => {
                    if (!hotelIds.has(item.id)) {
                        hotelIds.add(item.id);
                        result.push(item);
                    }
                });
            result.sort(function (a, b) {
                let textA = a.text.toUpperCase();
                let textB = b.text.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            })
            return result;
        },
        products: function () {
            let result = this.selectedHotel ? ApiClient.methods.distinct(
                this.productData
                    .filter(item => item.hotelId === this.selectedHotel.id)
                    .map(function (value) {
                        return {
                            "id": value.productId,
                            "text": value.productTitle,
                            "backedByContingents": value.backedByContingents,
                            "vacancies": value.vacancies
                        };
                    }),
                item => item.id
            ) : [];
            Logger.debug("products", result);
            this.selectedProduct = result && result.length === 1 ? result[0] : null;
            return result;
        },
        variants: function () {
            let result = this.selectedProduct ? ApiClient.methods.distinct(
                this.productData
                    .filter(item => item.productId === this.selectedProduct.id)
                    .map(function (value) {
                        return {
                            "id": value.productVariantId,
                            "text": value.productVariantTitle,
                            "backedByContingents": value.backedByContingents,
                            "vacancies": value.vacancies,
                            "duration": value.duration
                        };
                    }),
                item => item.id
            ) : null;
            Logger.debug("variants", result);
            this.selectedVariant = result && result.length === 1 ? result[0] : null;
            return result;
        },
        isManualCodeSelectionRequired: function () {
            return this.codeFromUrl === null && !this.isCodeValidated;
        },
        isStep1Visible: function () {
            // console.log("isStep1Visible", (this.isFormVisible && (!this.isOrderCompletionMode || this.step1Finished)));
            return this.isFormVisible && (!this.isOrderCompletionMode || !this.step1Finished);
        },
        isStep2Visible: function () {
            // console.log("isStep2Visible", (this.isFormVisible && (!this.isOrderCompletionMode || this.step1Finished)));
            return this.isFormVisible && (!this.isOrderCompletionMode || this.step1Finished);
        },
        isInternalMode: function () {
            return location.search.indexOf("internal=true") !== -1;
        },
        isOrderCompletionMode: function () {
            // console.log("isOrderCompletionMode", location.search.indexOf("internal=true") === -1);
            return location.search.indexOf("internal=true") === -1;
        }
    },
    mounted: function () {
        let code = this.codeFromUrl;
        if (code) {
            let ctx = this;
            this.brand = 'JochenSchweizer';
            this.bookingNumber = code;
            this.validateCode(() => {
            });
        } else {
            this.isLoading = false;
        }
    },
    watch: {
        brand: function (newBrand, oldBrand) {
            //this.updateProducts();
            document.title = 'Animod ' + (newBrand === 'MyDays' ? 'mydays' : newBrand) + '-Kooperation';
        }
    },
    methods: {
        toggleInfoPanel: function () {
            this.infoPanelVisible = !this.infoPanelVisible;
        },
        validateCode: function (cb) {
            let ctx = this;
            this.errors = [];
            this.isLoading = true;
            ApiClient.methods.validateCode({brand: this.brand, bookingNumber: this.bookingNumber})
                .then(response => {
                    Logger.debug(response);
                    if (response.data.isAvailableForBooking) {
                        let product = response.data.product;
                        this.productData = [product];
                        this.selectedHotel = {
                            "id": product.hotelId,
                            "text": product.hotelName
                        };
                        this.selectedProduct = {
                            "id": product.productId,
                            "text": product.productTitle,
                            "backedByContingents": product.backedByContingents,
                            "vacancies": product.vacancies
                        };
                        this.selectedVariant = {
                            "id": product.productVariantId,
                            "text": product.productVariantTitle,
                            "backedByContingents": product.backedByContingents,
                            "vacancies": product.vacancies,
                            "duration": product.duration
                        };
                        this.isProductPreselected = true;
                        this.isCodeValidated = true;
                        cb();
                    } else if (response.data.isExpired) {
                        ctx.errors = ["Diese Partnergutschein-Nummer ist leider nicht mehr gültig."];
                        ctx.isJsmdCustomerServiceInfoVisible = true;
                    } else if (response.data.isBooked || response.data.isSettled) {
                        ctx.errors = ["Diese Partnergutschein-Nummer wurde bereits eingelöst."];
                        ctx.isJsmdCustomerServiceInfoVisible = true;
                    } else if (response.data.isPending) {
                        ctx.errors = ["Für diese Partnergutschein-Nummer gibt es bereits eine offene Anfrage."];
                        ctx.isJsmdCustomerServiceInfoVisible = true;
                    } else if (response.data.isSoldOut) {
                        ctx.errors = ["Dieses Angebot ist leider ausverkauft."];
                        ctx.isJsmdCustomerServiceInfoVisible = true;
                    } else {
                        ctx.errors = ["Die Partnergutschein-Nummer ist ungültig."];
                        ctx.isJsmdCustomerServiceInfoVisible = true;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        // Logger.debug(error.response.data);
                        // Logger.debug(error.response.status);
                        // Logger.debug(error.response.headers);
                        this.errors = error.response.data.map(value => value.field + ": " + value.text);
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        Logger.debug(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        Logger.debug('Error', error.message);
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        showStep2: function () {
            let ctx = this;
            this.validateCode(() => {
                ctx.step1Finished = true;
            });
        },
        checkCode: function () {
            let ctx = this;
            this.validateCode(() => {
                ctx.isManualCodeSelectionRequired = false;
            });
        },
        reset: function () {
            this.step = "show-form";
            this.step1Finished = false;
            this.bookingNumber = null;
            this.firstname = null;
            this.lastname = null;
            this.email = null;
            this.comment = null;
            this.selectedHotel = null;
            this.selectedProduct = null;
            this.selectedVariant = null;
            this.quantity = 1;
            this.errors = [];
        },
        openCalendar(e, index) {
            let inputFields = document.getElementsByClassName("dpi-" + index);
            inputFields && inputFields.item(0).click();
        },
        clearDate(index) {
            this.updateDate(null, index);
        },
        updateProducts: function () {
            ApiClient.methods.getProducts(this.brand)
                .then(response => {
                    this.productData = response.data;
                    this.isLoading = false;
                }).catch((error) => {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    // Logger.debug(error.response.data);
                    // Logger.debug(error.response.status);
                    // Logger.debug(error.response.headers);
                    this.errors = error.response.data.map(value => value.field + ": " + value.text);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    Logger.debug(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    Logger.debug('Error', error.message);
                }
            });
        },
        customFormatter(date) {
            return ApiClient.methods.formatDate(date);
        },
        updateDate(value, index) {
            const dates = [...this.arrivalDates];
            dates[index] = !value ? '' : ApiClient.methods.formatDate(value);
            this.arrivalDates = dates;
        },
        appendDuration(index) {
            const date = ApiClient.methods.parseDate(this.arrivalDates[index]);
            if (date && this.selectedVariant) {
                const dateCopy = new Date(date.getTime());
                dateCopy.setDate(dateCopy.getDate() + this.selectedVariant.duration);
                const formatted = this.customFormatter(dateCopy);
                return formatted ? `(bis ${formatted})` : "";
            }
            return '';
        },
        onDateSelected() {
            Logger.debug("onDateSelected");
            let nonEmptyValues = this.arrivalDates.filter(item => item != null).length;
            let nonUniqueValues = this.arrivalDates
                .filter(item => item != null)
                .map(item => ApiClient.methods.formatDate(item))
                .filter((item, index, self) => self.indexOf(item) === index)
                .length
            ;
            if (nonUniqueValues < 1 && nonEmptyValues > nonUniqueValues) {
                //if ( this.errors.indexOf( nonUniqueDatesError ) === -1 ) {
                //    this.errors.push( nonUniqueDatesError );
                //}
                if (this.errors.indexOf(ERR_NON_UNIQUE_DATES) === -1) {
                    e
                    this.errors.push(ERR_NON_UNIQUE_DATES);
                }
            } else {
                //let errIndex = this.errors.indexOf( nonUniqueDatesError );
                let errIndex = this.errors.indexOf(ERR_NON_UNIQUE_DATES);
                if (errIndex !== -1) {
                    this.errors.splice(errIndex, 1);
                }
            }
        },
        sendRequestData: function () {
            if (!this.isCodeValidated) {
                this.checkCode();
            } else {
                Logger.debug("sendRequestData", this.arrivalDates);
                let nonEmptyValues = this.arrivalDates.filter(item => item != null).length;
                Logger.info("Found ", nonEmptyValues, " dates");
                if (nonEmptyValues >= 1) {
                    ApiClient.methods.sendRequestData(
                        {
                            "brand": this.brand,
                            "bookingNumber": this.bookingNumber,
                            "firstname": this.firstname,
                            "lastname": this.lastname,
                            "email": this.email,
                            "phone": this.phone,
                            "customerComment": this.comment,
                            "productVariantId": this.selectedVariant.id,
                            "quantity": this.quantity,
                            "finalizeOrder": this.isOrderCompletionMode,
                            "arrivalDates": this.arrivalDates
                                .filter(item => item != null)
                                //.map(item => ApiClient.methods.formatDate(item))
                                .filter((item, index, self) => self.indexOf(item) === index)
                        }
                    ).then(response => {
                        // response.data
                        this.showSuccessView();
                    }).catch((error) => {
                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            // Logger.debug(error.response.data);
                            // Logger.debug(error.response.status);
                            // Logger.debug(error.response.headers);
                            let errorMap = {
                                'bookingNumber.field.invalid': 'Die eingegebene Buchungsnummer ist ungültig.'
                            };
                            if (error.response && error.response.data) {
                                if (error.response.data.errors) {
                                    this.errors = error.response.data.errors.map(value => errorMap[value.field + "." + value.text] || (value.field + ": " + value.text));
                                } else {
                                    this.errors = error.response.data.map(value => errorMap[value.field + "." + value.text] || (value.field + ": " + value.text));
                                }
                            } else {
                                Logger.debug(error.response);
                                this.errors = ["Unknown error"];
                            }
                        } else if (error.request) {
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
                            Logger.debug(error.request);
                        } else {
                            // Something happened in setting up the request that triggered an Error
                            Logger.debug('Error', error.message);
                        }
                    });
                } else {
                    Logger.warn(ERR_NON_UNIQUE_DATES);
                    this.errors = [ERR_NON_UNIQUE_DATES];
                }
            }
        },
        showSuccessView: function () {
            Logger.debug("showSuccessView");
            this.step = "show-success";
        },
        updateHotelId: function (hotelId) {
            Logger.debug("updateHotelId", hotelId);
        }
    }
}
</script>

<style lang="scss">
.vs__dropdown-toggle {
    background: #fff;
}

html, body {
    height: 100%;
}

body {
    background-attachment: fixed;
    background-image: url(assets/avp_bck_phone@2x.jpg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    font-family: 'Lato', sans-serif;

    @media (min-width: 576px) {
        background-image: url(assets/avp_bck_phablet@2x.jpg);
    }
    @media (min-width: 768px) {
        background-image: url(assets/avp_bck_tablet@2x.jpg);
    }
    @media (min-width: 992px) {
        background-image: url(assets/avp_bck_small@2x.jpg);
    }
    @media (min-width: 1200px) {
        background-image: url(assets/avp_bck_large@2x.jpg);
    }
}

.customer-service-info {
    font-size: 1.1rem;

    span {
        font-size: 1.3rem;
        font-weight: bold;
    }
}

label {
    margin-top: 0.5rem !important;
    margin-bottom: 0 !important;
}

.avp-app {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .avp-app-wrapper {
        justify-content: center;
        min-height: 100%;
    }
}

.avp-app-content {
    .card {
        background-color: rgba(#fff, 0.75);
        border: none;
        border-radius: 0;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
        margin-top: 1.25rem;
        margin-bottom: 1.25rem;

        .card-header {
            background: rgba(#fff, 0.5);
            margin-bottom: 1px;
            border-radius: inherit;
        }

        .card-body {
            background: rgba(#fff, 0.5);
            padding-bottom: 0;

            height: auto;
            //transition: background-color 1s ease-in-out, height 3s ease-in-out;
            //transition: height 3s ease-in-out;

            a:not(.btn-primary) {
                color: #ff8933;
            }

            .card-title {
                color: #515151;
                font-weight: 500;
            }

            h2 {

                &.h4 {
                    margin-top: 20px;
                }

                span {
                    background: hsl(25, 100%, 60%);
                    width: 40px;
                    height: 40px;
                    display: inline-block;
                    border-radius: 20px;
                    text-align: center;
                    line-height: 40px;
                    margin-right: 10px;
                    color: #fff;
                    border: 1px solid hsl(40, 14%, 96%);
                }
            }

            .avp-form {
                /*background: rgba(#fff, 0.75);*/
                margin: -1.25rem -1.25rem 0;
                padding: 0.625rem 1.25rem;
                width: calc(100% + 2.5rem);

                .form-row {
                    @media (max-width: 575px) {
                        .btn {
                            display: block;
                            margin: 1.25rem auto 0;
                        }
                    }
                }

                .form-control[readonly] {
                    background: #fff;
                }

                .form-control[disabled] {
                    background: #eee;
                }
            }

            .card-navigation {
                display: flex;
                justify-content: center;
                padding-bottom: 1.25rem;
            }
        }

        .card-footer {
            background-color: rgba(#151515, 0.75);
            border-radius: inherit;
        }

    }

}

.text-primary {
    color: #ff8933 !important;
}

.btn-primary {
    background-color: #ff8933;
    background-image: linear-gradient(180deg, #ff984d 0%, #ff8933 100%);
    border: none;
    box-shadow: 0 0.0625rem 0.1875rem 0 rgba(0, 0, 0, 0.2);
    color: #1c1c1c;
    font-weight: bold;
    letter-spacing: 0.0625rem;
    position: relative;
    text-transform: uppercase;
    white-space: initial;
    z-index: 1;

    &:before {
        background-color: #ffa766;
        background-image: linear-gradient(180deg, #ffa766 0%, #ff8933 100%);
        border-radius: inherit;
        content: '';
        display: block;
        height: 100%;
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: -100;
        transition: opacity 0.3s ease-in-out;
    }

    &:hover, &:active {
        background-color: #ffa766;

        &:before {
            opacity: 1;
        }
    }
}

.btn-secondary {
    background-color: transparent;
    border-color: #6c757d;
    color: #6c757d !important;

    &:hover, &:active {
        color: #fff !important;
    }
}

.btn-outline-secondary {
    color: #6c757d !important;

    &:hover, &:active {
        color: #fff !important;
    }
}

.navigation-primary,
.navigation-secondary {
    display: flex;
    justify-content: center;
}

.navigation-primary {

    margin: 2.5rem 0 1.25rem;
}

.price-display {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.label-finishorder {
    color: #999;
    text-transform: uppercase;
    font-size: 1rem;
    line-height: 1rem;
}

.icon-tick {
    fill: hsl(124, 97%, 54%);
    width: 1.5em;
    height: 16px;
    position: relative;
    top: 0;
}

@keyframes svg--animation {
    0% {
        transform: rotateZ(0deg);
    }
    100% {
        transform: rotateZ(360deg)
    }
}

.spinner {
    width: 5em;
    animation: 2s linear infinite svg--animation;
    margin-bottom: 10px;
}

.vdp-datepicker {
    margin-bottom: 0.5rem;

    .vdp-datepicker__calendar {
        &.fullwidth-calendar {
            width: 100%;

            .cell {
                height: 2.75rem;
                line-height: 2.75rem;

                @media (max-width: 575px) {
                    height: 2.813rem;
                    line-height: 2.813rem;
                }
            }
        }

        .cell {
            height: 2.813rem;
            line-height: 2.813rem;
            font-weight: bold;


            &.highlighted {
                background: rgba(141, 228, 56, 0.3);
            }

            &.selected {
                background: #ff8933;
                color: #1c1c1c;
            }

            &:not(.disabled).day:hover {
                border: 1px solid #81d135;
            }
        }
    }
}


::v-deep .input-group .date-input {
    border-radius: 4px;

    &[readonly] {
        background-color: hsl(0, 0%, 100%);
    }
}


.checkin-dates {
    &__alternative-hint {
        display: block;
        color: #ff8933;
    }

    $muted-color: #a2a9ae;

    &__icon {
        width: 20px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        color: $muted-color;
        fill: currentColor;
        z-index: 10;
    }

    &__suffix {
        position: absolute;
        left: 8em;
        font-size: 80%;
        top: 12px;
        color: $muted-color;
        z-index: 10;
    }

    &__calendar-icon {
        right: 10px;
    }

    &__clear-icon {
        right: 35px;
        cursor: pointer;
    }

    &__info-icon {
        width: 20px;
        color: #ff8933;
        fill: currentColor;
        cursor: pointer;
    }
}
</style>